/* global $,site_url,grecaptcha */
import './jquery-global';
import 'slick-carousel';
import '@fancyapps/fancybox/dist/jquery.fancybox';
import Parallax from 'parallax-js';
import 'bootstrap/js/dist/modal';


$(function(){
  
  var ss_fade,
      ss_speed,
      ss_autoplay,
      ss_autoplay_speed;

	// Init ScrollMagic
	var controller = new ScrollMagic.Controller();
	
	//Animated anchors
	$(".scroll").on('click',function(event){
		event.preventDefault();
		$('html,body').animate({scrollTop:$('[name="'+this.hash.substring(1)+'"]').offset().top}, 500);
	});

	//Set footer reveal height
	setTimeout(function(){
		$("#wrap").css('margin-bottom',$("#footer").outerHeight());
	},500);

	//!FANCYBOX
	$('[data-fancybox]').fancybox({
		protect: true
	});

	// Open PHP Fancybox links by ajax
	$("[data-fancybox][href$='.php']").fancybox({
		padding: 0,
		scrolling: 'no',
		helpers : {
			overlay : {
				locked : true
			}
		},
		type: 'ajax'
	});

	var plx_img,
			plx_vid,
			module_id;
	//!WINDOW MODULE IMAGE PARALLAX
	if($(".module.window.scroll_parallax").length)
	{
		$(".module.window.scroll_parallax").each(function(){
			module_id = $(this).attr("id");
			plx_img = $(this).find("img");

			new ScrollMagic.Scene({triggerElement: "#"+module_id, triggerHook: 'onEnter', duration: "200%" })
								.setTween(plx_img, {y: "-20%", ease: Linear.easeNone})
								.addTo(controller);
		});
	}

	//!WINDOW MODULE VIDEO PARALLAX
	if($(".module.window.scroll_video_parallax").length)
	{
		$(".module.window.scroll_video_parallax").each(function(){
			module_id = $(this).attr("id");
			plx_vid = $(this).find("video");

			new ScrollMagic.Scene({triggerElement: '#'+module_id, triggerHook: 'onEnter', duration: "200%" })
								.setTween(plx_vid, {y: "-20%", ease: Linear.easeNone})
								.addTo(controller);
		});
	}

	//!LAYERED PARALLAX
	var parallax_elemts = document.querySelectorAll(".parallax");
	var i;
	for (i = 0; i < parallax_elemts.length; i++) {
  	new Parallax(parallax_elemts[i]);
	}

  //// MOBILE NAV
  var mobileNav_btn = $("#header .hamburger"),
      navbar = $(".nav-main");

  $(document).on('click',"#header .hamburger",function(e){
    e.preventDefault();
    if(mobileNav_btn.hasClass("is-active"))
    {
      // Menu is open
      mobileNav_btn.removeClass("is-active");
      navbar.removeClass("nav-open");
    }
    else
    {
      // Menu is closed
      mobileNav_btn.addClass("is-active");
      navbar.addClass("nav-open");
    }
  });

	var infoPin,
		ss = [],
		ss_id = [],
		ssp = [],
    ssp_id = [],
    ss7col = [],
		ss7col_id = [];


	/* !SLIDESHOW MODULES */
	/*-----------------------------------------------------------------------------------*/

  // Parallax layered slideshows
	if($(".module-slideshow_parallax_layered").length)
	{
		$(".module-slideshow_parallax_layered").each(function(index) {
			ssp[index] = $(this).find(".slideshow");
			ssp_id[index] = $(this).attr("id");
			ssp[index].slick({
				arrows: true,
				prevArrow: "#"+ssp_id[index]+" .pager .prev",
				nextArrow: "#"+ssp_id[index]+" .pager .next",
				dots: true,
				appendDots: "#"+ssp_id[index]+" .pager .pages"
			});
		});
	}

  // Standard slideshows
	if($(".slideshow.module").length)
	{
		ss_fade = false;
    ss_speed = 1000;
    ss_autoplay = false;
    ss_autoplay_speed = 0;

		$(".slideshow.module").each(function(index) {
			ss[index] = $(this).find(".slides");
			ss_id[index] = $(this).attr("id");

			if($(this).hasClass("window"))
			{
				ss_fade = true;
				ss_autoplay = true;
				ss_autoplay_speed = 5000;
			}

			ss[index].slick({
				fade: ss_fade,
				slides: '> .slide',
				speed: ss_speed,
				autoplay: ss_autoplay,
				autoplaySpeed: 		ss_autoplay_speed,
				dots: true,
				arrows: true,
				appendDots: "#"+ss_id[index]+" .pager .pages",
				prevArrow: "#"+ss_id[index]+" .pager .prev",
				nextArrow: "#"+ss_id[index]+" .pager .next"
			});

		});
  }
  
  // 7 column carousel sliders
  if($(".slideshow-7col").length) {
		$(".slideshow-7col").each(function(index) {
			ss7col[index] = $(this).find(".slides");
			ss7col_id[index] = $(this).attr("id");

			ss7col[index].slick({
				fade: false,
        slides: '> .slide',
        slidesToShow: 7,
        slidesToScroll: 7,
				speed: 1000,
				autoplay: false,
				dots: true,
				arrows: true,
				appendDots: "#"+ss7col_id[index]+" .pager .pages",
				prevArrow: "#"+ss7col_id[index]+" .pager .prev",
        nextArrow: "#"+ss7col_id[index]+" .pager .next",
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
			});

		});
  }

  // Project slideshows
  ss_fade = false;
  ss_speed = 1000;
  ss_autoplay = false;
  ss_autoplay_speed = 0;
  let projectModals = {};
  let projectCarousels = {};
  let projectIds = {};
  if($('.module-project-group .grid-item-media').length) {
    $(".module-project-group .grid-item-media").each(function(index) {
      projectModals[index] = $(this);
      projectIds[index] = $(this).data('id');
      projectModals[index].fancybox({
        src: '#project-'+projectIds[index],
        touch: false,
        afterShow: function(instance,current) {
          // Load any videos
          let projectVideoEmbeds = $(current.$content[0]).find('.video-load');
          console.log(projectVideoEmbeds);
          if(projectVideoEmbeds.length) {
            projectVideoEmbeds.each(function(){
              let video_id = $(this).data('video_id');
              console.log(video_id);
              if(video_id) {
                console.log(theme_url+'ajax/get_oembed.php');
                $(this).load(theme_url+'ajax/get_oembed.php',{
                  video_id: video_id
                },function(){
                  $(this).removeAttr('data-video_id');
                });
              }
            });
          }
          // Initialise the sliders
          projectCarousels[index] = $(current.$content[0]).find('.project-carousel');
          if(projectCarousels[index].length) {
            projectCarousels[index].slick({
              fade: ss_fade,
              slides: '> .slide',
              speed: ss_speed,
              autoplay: ss_autoplay,
              autoplaySpeed: ss_autoplay_speed,
              dots: true,
              arrows: true,
              infinite: false,
              appendDots: '#project-'+projectIds[index]+' .pager .pages',
              prevArrow: '#project-'+projectIds[index]+' .pager .prev',
              nextArrow: '#project-'+projectIds[index]+' .pager .next'
            });
            window.dispatchEvent(new Event('resize'));
          }
        }
      });
    });
  }

  //// MODAL
  var modal = $("#modal_default_global_modal");
  function setModal(type,title,body) {
    modal.find('.modal-content').removeClass().addClass('modal-content '+type);
    if(title !=='') {
      modal.find('.modal-title').html(title);
    }
    if(body !=='') {
      modal.find('.modal-body').html(body);
    }
  }
  function showModal(type,title,body) {
    setModal(type,title,body);
    modal.modal('show');
  }

  //// FIELDS & LABELS
  var field,
  field_block;

  //// Float Labels

  // Add focus class to filled fields on page load
  $('.float-label input').filter(function () {
    if(this.value.length > 0) {
      $(this).closest(".float-label").addClass("focus");
    }
  });

  // When field is focussed
  $(document).on("focus", ".float-label .form-control", function() {
    field = $(this); 
    field_block = field.closest(".float-label");
    if(!field.prop('disabled')) {
      field_block.addClass("focus");
    }
  });

  // When field loses focus
  $(document).on("blur", ".form-control", function() {
    field = $(this);
    field_block = field.closest(".float-label");
    if(field.val().length === 0) {
      field_block.removeClass("focus");
    }
  });

  //// FORM SUBMISSIONS
  /*----------------------------------------------------------------------------*/
  var btn,
  form,
  formdata,
  feedback,
  error_msg;

  $(document).on("submit", ".tr_form", function(e) {
    e.preventDefault();
    form = $(this);
    btn = form.find('button[type=submit]');
    // modal = form.find('.modal');
    feedback = form.find('.feedback');
    error_msg = false;

    //Capture new form data
    formdata = form.serializeArray();
    formdata.push({
      "name": "submit",
      "value": 1
    });

    $(".formdata").each(function(){
      if($(this).attr("type") === 'checkbox')
      {
        if($(this).prop("checked") === true)
        {
          formdata.push({
              "name": this.name,
              "value": $(this).val()
          });
        }
      }
      else
      {
        formdata.push({
            "name": this.name,
            "value": $(this).val()
        });
      }
    });

    //Disable the save button and add "waiting" status
    btn.prop("disabled",true).addClass("running");
    //Remove error styling on all fields
    form.find(".field,.field input,.field textarea,.field select").removeClass("is-invalid").closest(".field").find('.invalid-feedback').remove();
    // Hide feedback alert (if present)
    feedback.hide();

    // Only continue if there is some form data
    if(formdata.length) {

      // Reformat the formdata array so we can read values by name
      var formddata_obj = {};
      $(formdata).each(function(i, field){
        formddata_obj[field.name] = field.value;
      });

      // Only continue if the recaptcha key and action name exists
      if(formddata_obj.recaptcha_key) {

        // Get the recaptcha token and add it to the form data before submission
        grecaptcha.ready(function() {
          grecaptcha.execute(formddata_obj.recaptcha_key, { action: formddata_obj.form }).then(function(token) {

            // Add the token to the post data
            formdata.push({
              "name": "recaptcha_token",
              "value": token
            });        

            // Submit the data
            $.ajax({
              url:  site_url+'site/ajax/form_process.php',
              type: 'post',                
              data: formdata,
              dataType: "json"
            })
            .done(function(data) {
              if(data.success) {
                //Reset the form
                form.trigger("reset");

                form.find(".field").removeClass("focus").removeClass("is-invalid").val(null);
                form.find(".form-control").val(null);

                form.find("select[multiple]").val(null).trigger('change');
                
                //Enable save button
                setTimeout(function(){
                  btn.prop("disabled",false).removeClass("running");
                }, 1000);

                //Display success message
                if(data.modal_feedback) {
                  showModal('success',data.success_header,data.success);
                }
                else {
                  feedback.removeClass('error').addClass('success');
                  feedback.html('<h4 class="alert-heading">'+data.success_header+'</h4><p>'+data.success+'</p>').slideDown();
                }
              }
              else {
                if(!$.isEmptyObject(data.errors)) {
                  $.each(data.errors,function(i,val) {
                    // If the key is 'dummy' show a general error
                    if(i === 'dummy') {
                      error_msg = val;
                    }
                    // If the key matched a field name, highlight the field and show the error underneath
                    else {
                      form.find(".field [name='"+i+"'],.field [name='"+i+"[]']")
                        .addClass("is-invalid")
                        .closest(".field")
                        .addClass("is-invalid")
                        .append('<p class="invalid-feedback">'+val+'</p>');
                    }
                  });
                  if(error_msg) {
                    if(data.modal_feedback) {
                      showModal('error',data.error_header,error_msg);
                    }
                    else {
                      feedback.removeClass('success').addClass('error');
                      feedback.html('<h4 class="alert-heading">'+data.error_header+'</h4><p>'+error_msg+'</p>').slideDown();
                    }
                  }
                  else {
                    if(data.modal_feedback) {
                      showModal('error',data.error_header,'We couldn\'t submit this form.  Please correct the marked fields and try again.');
                    }
                    else {
                      feedback.removeClass('success').addClass('error');
                      feedback.html('<h4 class="alert-heading">'+data.error_header+'</h4><p>We couldn\'t submit this form.  Please correct the marked fields and try again.</p>').slideDown();
                    }
                  }
                }
              }

              //Enable save button
              setTimeout(function(){
                btn.prop("disabled",false).removeClass("running");
              }, 1000);
            });
          });
        });
      }
      else {
        error_msg = 'The validation key is missing';
        if(feedback.length) {
          feedback.removeClass('success').addClass('error');
          feedback.html('<h4 class="alert-heading">There was a problem</h4><p>'+error_msg+'</p>').slideDown();
        }
        else {
          showModal('error','There was a problem',error_msg);
        }
        //Enable save button
        setTimeout(function(){
          btn.prop("disabled",false).removeClass("running");
        }, 1000);      
      }
    }
  });

	/* !DESKTOP ONLY BEHAVIOUR */
	/*-----------------------------------------------------------------------------------*/
	function global_desktop_setup() {

		// Pin the page actions strip until the first module leaves the viewport
		if($("#page-actions").length)
		{
			var bannerHeight = $(".module.first").height();
			var pageInfoHeight = $("#page-actions").height();
			var duration = bannerHeight - pageInfoHeight;
			infoPin = new ScrollMagic.Scene({triggerElement: "body",triggerHook: "onLeave", duration: duration})
				.setPin("#page-actions")
				.addTo(controller);
		}

	}

	function global_desktop_teardown() {
		if (typeof infoPin !== 'undefined' && infoPin) {
			infoPin.destroy();
		}
		$(".scrollmagic-pin-spacer,#page-actions").removeAttr("style");

	}

	/* !MOBILE ONLY BEHAVIOUR */
	/*-----------------------------------------------------------------------------------*/

	function global_mobile_setup() {

	}

	function global_mobile_teardown() {

	}

	var mobileview = window.matchMedia('screen and (max-width:770px)');

	//!On page load
	if (mobileview.matches) {
		//!Mobile only functions
		global_mobile_setup();
	}
	else {
		//!Non-mobile functions
		global_desktop_setup();
	}

	/* !LISTENER FOR MEDIA QUERY CHANGES */
	/*-----------------------------------------------------------------------------------*/

	mobileview.addListener(function() {
		if (mobileview.matches) {
			//!Mobile only functions
			global_desktop_teardown();
			global_mobile_setup();
		}
		else {
			//!Non-mobile functions
			global_mobile_teardown();
			global_desktop_setup();
		}
	});

});
